
  import { defineComponent, computed } from 'vue';
  import { InspectionActivity } from '@/entities/activity/model';
  import { CreatedAt } from '@/ui/components/activityLogs/common/CreatedAt';
  import { t } from '@/ui/i18n/i18n';
  import { boldifyStringArray } from '@/ui/components/activityLogs/helpers';

  interface ApprovalRejectedProps {
    resourceName: string;
    log: InspectionActivity;
  }

  export default defineComponent<ApprovalRejectedProps>({
    name: 'ApprovalRejected',
    components: {
      CreatedAt,
    },
    props: ['resourceName', 'log'],
    setup(props) {
      const activityMessage = computed(() => {
        const { comment } = props.log.payload;
        const transKey = comment
          ? 'activity-logs.approval-rejected-comment'
          : 'activity-logs.approval-rejected';
        return t(transKey, {
          username: boldifyStringArray([props.log.user?.name ?? '']),
          comment: comment as string,
        });
      });

      return {
        activityMessage,
      };
    },
  });
